<template>
  <main class="mt-3">
    <div class="container">
      <h2 class="text-center"><u>공지상세</u></h2>
      <div class="mb-3 mt-2 row">
        <label class="col-md-3 col-form-label">공지제목<span class="text-danger">*</span></label>
        <div class="col-md-9">
          <div class="input-group">
            <select class="form-select form-select-sm text-primary" aria-label=".form-select-sm" ref="sel_ctCd" v-model="notice.ctCd" disabled>
              <option value="">공지카테고리선택</option>
              <option value="NT">공지</option>
              <option value="EV">이벤트</option>
              <option value="TR">여행관련</option>
              <option value="MO">항공선박</option>
              <option value="PR">홍보/안내</option>
            </select>          
            <input type="text" class="form-control w-75" ref="txt_nTitle" v-model="nTitle">
          </div>

          <!-- <div class="mt-3 mb-3 row" v-if="notice.ctCd == 'EV' || notice.ctCd == 'PR'">
            <div class="col-md-9">
              <span class="mb-2 fw-bold">
                ※ 이벤트와 홍보는 게시기간을 지정합니다&nbsp;&nbsp;(미지정 시, 상시노출됩니다)
              </span>
              <div class="input-group mb-3">
                <span class="input-group-text" id="basic-addon1">개시</span>
                <input type="date" class="form-control" v-model="nFrom" ref="txt_fromDate">
                <span class="input-group-text" id="basic-addon1">종료</span>
                <input type="date" class="form-control" v-model="nTo" ref="txt_toDate">
              </div>
            </div>
          </div> -->
        </div>
      </div>

      <hr>
      
      <div class="mb-3 row">
        <label class="col-md-3 col-form-label">
          Thumbnail 이미지 사용&nbsp;
          <span style="display: inline-flex; align-items: left;">
            <input class="form-check-input" type="checkbox" true-value="Y" false-value="N" v-model="thFlag" ref="dType" @change="checkThumb(thFlag)">
          </span>

          <!-- <br><span style="font-weight: normal; color: gray;">※팝업 시, 이미지로도 사용됨</span> -->
        </label>
        <div class="col-md-9">
          <div class="col-md-9">
            <div class="position-relative">
                <img :src="`/download/notice/${this.notice.ctCd}/${this.notice.noticeCode}.jpg`" class="img-fluid" v-if="this.notice.thumbNail === 'Y'"/>
                <div v-if="this.notice.thumbNail === 'Y'">
                  <p class="position-absolute top-0 end-70" style="cursor:pointer;" @click="sealingImage(this.noticeCode, 'N')">
                    <i class="bi bi-trash text-danger fs-4"></i>
                  </p>
                </div>
              </div>            
            <input type="file" class="form-control" id="fileSelectorImage" accept="image/jpeg">
            <div class="alert alert-secondary" role="alert" style="font-size: 1rem;">
              <div class="text-danger fw-bold">- File 종횡비: 1:1</div>
              <div>- File 확장자: jpg</div>
              <div>- File 크기&nbsp;&nbsp;&nbsp;&nbsp;: 3메가 이하</div>
            </div>
          </div>
        </div>
      </div>
      
      <hr>

      <div class="mb-3 row">
        <label class="col-md-3 col-form-label">공지내용<span class="text-danger">*</span></label>
        <div class="col-md-9">
          <!-- QuillEditor호출 -->
          <div>
            <quill-editor v-model:content="content" :options="editorOption" @saveDocument="handleSaveDocument" />
          </div>
        </div>
      </div>

      <div class="mb-3 row">
        <div class="col-auto d-grid p-1"> 
          <button type="button" class="btn btn-lg btn-danger" @click="goToList">공지리스트</button>
        </div>
      </div>
    </div>
  </main>

</template>

<script>
import QuillEditor from '@/components/QuillEditor.vue'
import axios from 'axios'
// import moment from 'moment';
import { deleteFile } from '../assets/js/commonFunctions'

export default {
  components: { QuillEditor },

  data() {
    return {
      notice: [],

      nTitle: "",
      nFrom: null,
      nTo: null,
      // insDate: "",
      insId: "",
      nUseFlag: "N",             //공지상태 default: 비공지
      noticeCode: "",            //공지코드
      fixedFlag: "N",            //고정공지여부

      // QuillEditor관련
      quillFlag: "Y",    // Quill Editor 사용여부
      //filename: "",      // 저장할 공지사항내용(공지코드.md)
      content: "",
      editorOption: {
        placeholder: '공지내용을 입력해주세요...',
        modules: {
          toolbar: 
          {
            container: [
              ['bold','italic','underline','strike'],
              ['blockquote','code-block'],
              [{ header: 1 }, { header: 2 }],
              [{ list: 'ordered' }, { list: 'bullet' }],
              [{ script: 'sub' }, { script: 'super' }],
              [{ indent: '-1' }, { indent: '+1' }],
              [{ direction: 'rtl' }],
              [{ size: ['small', false, 'large', 'huge'] }],
              [{ header: [1,2,3,4,5,6,false] }],
              [{ color: [] }, { background: [] }],
              [{ font: [] }],
              [{ align: [] }],
              ['clean'],
              ['link','image','video'],
              [{ 'imageLink': [] }], // 커스텀 툴 추가 (아래에서 핸들러 연결)
            ],
            handlers: {
              imageLink: function() {       //arrow function 사용금지(바인딩이 깨짐)
                // this는 quill 인스턴스!
                const range = this.quill.getSelection();
                if (range) 
                {
                  const [leaf] = this.quill.getLeaf(range.index);
                  if (leaf && leaf.domNode.tagName === 'IMG') 
                  {
                    const url = window.prompt('이미지에 하이퍼링크(URL)을 입력하세요:');
                    if (url) 
                    {
                      const imgNode = leaf.domNode;
                      const parent = imgNode.parentNode;
                      if (parent.tagName !== 'A') 
                      {
                        const linkNode = document.createElement('a');
                        linkNode.setAttribute('href', url);
                        linkNode.setAttribute('target', '_blank');
                        parent.replaceChild(linkNode, imgNode);
                        linkNode.appendChild(imgNode);
                      } 
                      else 
                      {
                        parent.setAttribute('href', url);
                      }
                    }
                  }
                }
              }
            }
          },
          imageResize: {                        //반드시 추가!
            parchment: window.Quill
              ? window.Quill.import('parchment')
              : undefined,
            modules: ['Resize', 'DisplaySize', 'Toolbar']  // 필요하다면 Toolbar 포함
          }
        },

        formats: [
          'bold','italic','underline','strike','blockquote','code-block','header','list',
          'script','indent','direction','size','color','background','font','link','image','video',
          'align', 'float', 'width', 'height'
        ]
      },

      thFlag: "N",                //썸네일사용여부
      //noticeThumbnail: [],      //공지썸네일정보
    };
  },
    // 로그인된 사용자만 접근가능페이지
  computed: {
    user() {
      return this.$store.state.user;
    }
  },
  created() {
    this.noticeCode = this.$route.query.seqNotice;
    this.ctCd = this.$route.query.ctCd;
    this.getNoticeDetail();
  },  
  mounted() {
    if(document.referrer == "") {
      this.$swal.fire('', '적절하지 않은 페이지 접근입니다.', 'error');
      location.replace("/")
    }
    //권한없는 로그인 차단
    if(this.user.handlerId == undefined || this.user.handlerGrade >= 20) {
      var swal = require('sweetalert2');
      swal.fire({
        title: '로그인 필요',
        text: '접근권한 확인불가.',
        icon: 'error'
      });
      this.$router.push({path: '/b2bLogin'});
    }
    //document.getElementById("notice").style.display = "none";
    document.getElementById("user").style.display = "none";

    //오늘날짜추출
    const date = new Date(+new Date() + 3240 * 10000).toISOString().split("T")[0]
    const time = new Date().toTimeString().split(" ")[0];
    this.today = date + ' ' + time;
    //let tStamp = "";
    this.tStamp = new Date().getTime();

    this.getNotice_md(this.noticeCode);
  },
  methods: {
    checkThumb(thFlag) {
      this.thumbFlag = thFlag;
      //console.log("thumbFlag:", this.thumbFlag);
    },
        
    // Quill Editor관련
    onEditorChange({ html }) {
      this.internalContent = html         // 내부 상태만 변경
      this.$emit('update:content', html)  // 부모에 변경 알림
    },
    saveDoc() {
      const html = this.$refs.quillRef?.$el?.querySelector('.ql-editor')?.innerHTML || this.internalContent 
      this.$emit('saveDocument', { content: html })
      // this.$emit('saveDocument', { content: this.internalContent })
    },

    getDateFormat(date) {
      return this.$dateFormat(date);
    },

    async getNoticeDetail() {
      //let nDetail = await this.$api("/api/noticeDetail", {param: [this.noticeCode]});
      let nDetail = await this.$api("/api/noticeDetail_new", {param: [this.noticeCode]});
      if(nDetail.length > 0) {
        this.notice = nDetail[0];
        this.nTitle = this.notice.nTitle
        // this.nFrom  = (!this.notice.nFrom) ? null : this.getDateFormat(this.notice.nFrom)
        // this.nTo    = (!this.notice.nTo) ? null : this.getDateFormat(this.notice.nTo)
        this.thFlag = this.notice.thumbFlag
      }
      //console.log("notice:",this.notice)
    },

    // 저장된 md파일 불러오기
    async getNotice_md(nCode) {
      let filename = `${nCode}.md`;
      document.querySelectorAll('.ql-editor img').forEach(img => img.removeAttribute('style'));

      try 
      {
        let response = await axios.get(`/uploads/notice/${this.ctCd}/${filename}`);
        if (response.data.success) 
        {
          this.content = response.data.content;
        } 
        else 
        {
          throw new Error('Failed to load document');
        }
      } 
      catch (error) 
      {
        this.$swal.fire('', '에디팅된 공지문서가 없습니다', 'info');
      }      
    },

    goToList() 
    {
      this.$router.push({path: '/noticeList'});
    },

    // 공지변경 업데이트
    async handleSaveDocument(payload) {
      // 카테고리 체크
      if (!this.notice.ctCd || this.notice.ctCd === '') 
      {
        this.$swal.fire('', '공지카테고리를 선택하세요', 'warning');
        return false;
      }

      // 제목 체크
      if (!this.nTitle || this.nTitle.trim() === '') 
      {
        this.$swal.fire('', '공지제목을 입력하세요', 'warning');
        return false;
      }

      // 내용 체크
      if (!payload.content || payload.content.trim() === '') 
      {
        this.$swal.fire('', '공지내용을 입력하세요', 'warning');
        return false;
      }

      // 썸네일 처리 부분
      let imgFile = document.getElementById('fileSelectorImage').files;
      if (imgFile && imgFile.length > 0) 
      {
        let fileLength    = imgFile[0].name.length;
        let fileType_tmp  = imgFile[0].name.lastIndexOf(".");
        let extension     = imgFile[0].name.substring(fileType_tmp + 1, fileLength).toLowerCase();
        let fileType      = imgFile[0].type;

        if (fileType != "image/jpeg" || extension !== "jpg") 
        {
          this.$swal.fire('', '썸네일은 jpg 이미지만 지원합니다.', 'warning');
          return false;
        } 
        else if (imgFile[0].size > 3 * 1024 * 1024) 
        {
          this.$swal.fire('', '썸네일은 3MB 이하만 가능합니다.', 'warning');
          return false;
        } 
        else 
        {
          this.thumbNail = "Y"; // 새 이미지 등록됨
        }
      } 
      else 
      {
        // 새 파일이 없으면 상태를 기존 그대로 유지
        this.thumbNail = this.notice.thumbNail;
      }

      try 
      {
        // EV/PR 카테고리만 기간 설정
        // this.nFrom = (this.notice.ctCd === 'EV' || this.notice.ctCd === 'PR') ? (this.nFrom) : null;
        // this.nTo   = (this.notice.ctCd === 'EV' || this.notice.ctCd === 'PR') ? (this.nTo) : null;
        // this.nFrom = (!this.nFrom || this.nFrom == "") ? null : this.getDateFormat(this.nFrom)
        // this.nTo   = (!this.nTo || this.nTo == "") ? null : this.getDateFormat(this.nTo)
        this.insId = this.user.handlerId;

        // md 파일 저장
        let filename = `${this.noticeCode}.md`;
        let response = await this.$api(`/uploads/notice/${this.ctCd}/`, { content: payload.content, filename: filename });

        if (response.success === true) {
          // 썸네일 업로드(선택된 파일이 있으면 덮어쓰기)
          if (imgFile && imgFile.length > 0) {
            await this.uploadFile(imgFile, this.ctCd, this.noticeCode, "image");
          }

          let addImageFlag = "";
          let addVideoFlag = "";
          // DB 업데이트(공지 변경)
          let resUpd_notice = await this.$api("/api/noticeUpdate2", {param: [
            this.nTitle, '', this.nFrom, this.nTo, this.insId, addImageFlag, addVideoFlag, this.thFlag, this.thumbNail, this.noticeCode
          ]});

          if (resUpd_notice.affectedRows < 0) {
            this.$swal.fire('','변경 중 오류가 발생했습니다. 재시도해 주세요', 'warning');
            return false;
          } else {
            this.$swal.fire('','변경되었습니다.', 'success');
            location.reload(true);
          }
        } else {
          this.$swal.fire('', '공지사항 저장 중 오류가 발생했습니다.', 'warning');
        }
      } 
      catch (error) 
      {
        // console.log("Error saving document:>>>>>", error);
        this.$swal.fire('', '문서 저장 중 오류가 발생했습니다.', 'error');
      }
    },

    /** 이미지 or 동영상 사본등록 */
    async uploadFile(file, id, passNo, fileType) {

      let files = ""

      if (file[0].size > 3 * 1024 * 1024) 
      {
        files = await this.compressFile(file[0], fileType)
      }
      else
      {
        files = file[0];
      }
      
      // let fileLength = 0
      // let fileType_tmp = "";
      let licenseFile = "";
      //let uploadedFile = "";
      let data = null;

      if (files) 
      {
        licenseFile = `${passNo}.jpg`;
        data = await this.$base64(files);

        const { error } = await this.$api(`/upload/notice/${id}/${licenseFile}`, { data });

        if (error) 
        {
          return this.$swal("업로드(uploadFile) 오류발생, 재시도 필요.");
        }
      }
    },

    async compressFile(file, fileType) 
    {
      // 이미지 크기한도: 2메가
      if (fileType === "image" && file.size > 3 * 1024 * 1024) 
      {
        console.log("이미지 압축 중...");
        return await this.compressImage(file);
      } 
      // 동영상 크기한도: 20메가
      else if (fileType === "video" && file.size > 20 * 1024 * 1024) 
      {
        // console.log("동영상 압축 중...");
        // return await this.compressVideo(file);           // 압축api의 초기화 불능으로 적용홀딩(2024-11-28)
        this.$swal.fire("","동영상 업로드는 20메가 미만으로 제한됩니다", "warning")
        return false;
      }
      return file; // 크기 초과하지 않으면 원본 파일 반환
    },

    async compressImage(file) {
      const reader = new FileReader();

      return new Promise((resolve, reject) => {
        reader.onload = (event) => {
          const img = new Image();
          img.onload = () => {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");

            const maxDimension = 3200;
            let width = img.width;
            let height = img.height;

            if (width > maxDimension || height > maxDimension) {
              if (width > height) {
                height = Math.round((height * maxDimension) / width);
                width = maxDimension;
              } else {
                width = Math.round((width * maxDimension) / height);
                height = maxDimension;
              }
            }

            canvas.width = width;
            canvas.height = height;
            ctx.drawImage(img, 0, 0, width, height);

            canvas.toBlob(
              (blob) => {
                if (blob.size > 3 * 1024 * 1024) 
                {
                  reject(new Error("이미지를 5MB 이하로 압축할 수 없습니다."));
                } 
                else 
                {
                  resolve(new File([blob], file.name, { type: "image/jpeg" }));
                }
              },
              "image/jpeg",
              1.0 // 품질 설정
            );
          };
          img.src = event.target.result;
        };
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    },

    sealingImage(nSeqNo, flag) {
      this.$swal.fire({
        text: '썸네일을 삭제합니까?',
        showCancelButton: true,
        confirmButtonText: `Yes`,
        cancelButtonText: `No`
      }).then(async (result) => {
        if (result.isConfirmed) 
        {          
          //공지는 동영상 또는 이미지 택1이므로 분기가 필요없다
          let result = await this.callDeleteFile()

          if(result === "OK")
          {
            this.thumbNail = "N"
            await this.$api("/api/noticeImageSealing_new",{param:[ this.user.handlerId, flag, flag, flag, this.thumbNail, nSeqNo ]});
            this.$swal.fire('', '파일삭제완료', 'success').then(() => {
              location.reload(true)
            })
          }
          else
          {
            this.$swal.fire('', '파일삭제실패. 재시도해주시고, 반복실패되면 관리자에 문의해주세요', 'error')
            return false
          }
        } 
      });
    },

    //파일삭제함수 공통함수호출
    async callDeleteFile()
    {
      // console.log(this.notice.addImageFlag, "//", this.notice.addVideoFlag)
      let fileExt = "jpg"
      // if(this.notice.addImageFlag === "Y" && (this.notice.addVideoFlag === "" || this.notice.addVideoFlag == null || this.notice.addVideoFlag === "N"))
      // {
      //   fileExt = "jpg"
      // }
      // else if(this.notice.addVideoFlag === "Y" && (this.notice.addImageFlag === "" || this.notice.addImageFlag == null || this.notice.addImageFlag === "N"))
      // {
      //   fileExt = "mp4"
      // }
      
      let targetPath = ""
      let fileName = ""
      let retVal = ""

      targetPath = `/notice/${this.notice.ctCd}/`
      fileName = `${this.notice.noticeCode}.${fileExt}`
      //console.log("targetPath:", targetPath, "fileName:", fileName)

      retVal = await deleteFile(this.$api, targetPath, fileName);
      //console.log("retVal:", retVal)

      return retVal
    },

    async noticeUpdate()
    {
      if(!this.notice.nTitle) {
        this.$refs.txt_nTitle.focus();
        return this.$swal.fire("필수누락: 공지제목");
      }
      if(!this.notice.nContent) {
        this.$refs.txt_nContent.focus();
        return this.$swal.fire("필수누락: 공지내용");
      }
      // this.notice.nFrom = (this.notice.nFrom == undefined) ? null : moment(this.notice.nFrom).format("YYYY-MM-DD");
      // this.notice.nTo   = (this.notice.nTo == undefined) ? null : moment(this.notice.nTo).format("YYYY-MM-DD");

      this.notice.updId = this.user.handlerId;

      let addImageFlag = ""
      let addVideoFlag = ""
      let resUpd_notice = await this.$api("/api/noticeUpdate2", {param: [
        this.notice.nTitle, this.notice.nContent, this.notice.nFrom, this.notice.nTo, this.notice.updId, addImageFlag, addVideoFlag, this.thumbFlag, this.noticeCode
      ]});
      
      if(resUpd_notice.affectedRows < 0)
      {
        this.$swal.fire('','변경 중 오류가 발생했습니다. 재시도해 주세요', 'warning');
        return false
      }
      else
      {
        this.$swal.fire('','변경되었습니다.', 'success');
        location.reload(true)
      }
    },    
  }
}
</script>

<style scoped>
  label {
    font-weight: bold;
    font-size: 1.1rem;
  }
</style>